module.exports = __webpack_public_path__ + "static/Mailmerge-mp.15018be7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Mailmerge-mp.jpg
// module id = 123
// module chunks = 133428282160390 225901961288281